// extracted by mini-css-extract-plugin
module.exports = {"contentBase":"styles_contentBase__Oyg5C"};